import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('pointModeDropdown');

    return {
        RETICLE: t('reticle'),
        TOUCH: t('touch')
    };
};

export default useTranslation;
